import { useQuery } from '@apollo/client/react';

import { GetPendingMedicineNoteAutoLinkCountDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const usePendingMedicineNoteAutoLinkCount = () => {
  const { data, loading } = useQuery(GetPendingMedicineNoteAutoLinkCountDocument, {
    fetchPolicy: 'cache-and-network',
  });
  const pendingCount = data ? getMe(data)?.organization.pendingMedicineNoteAutoLinkCount || 0 : 0;

  return { loading, pendingCount };
};
